<template>
  <div class="pwd">
    <el-card class="msg">
      <div class="title">{{ $t("perCar.myShopCart") }}</div>
      <div class="topBox">
        <el-row>
          <el-col :span="3">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
            ></el-checkbox>
            {{ $t("perCar.all") }}
          </el-col>
          <el-col :span="7"> {{ $t("perCar.goodsInfo") }} </el-col>
          <el-col :span="5"> {{ $t("perCar.unitPrice") }} </el-col>
          <el-col :span="4"> {{ $t("perCar.quantity") }} </el-col>
          <el-col :span="3"> {{ $t("perCar.totalPrices") }} </el-col>
          <el-col :span="2"> {{ $t("perCar.operation") }} </el-col>
        </el-row>
      </div>
      <!-- <span @click="daying()">答应</span> -->

      <ul>
        <el-checkbox-group v-model="multipleSelection">
          <li v-for="(item, index) in list" :key="index">
            <el-row>
              <el-col class="fz-col-1" :span="2">
                <el-checkbox :label="item.id"></el-checkbox>
              </el-col>
              <el-col class="fz-col-2" :span="8">
                <el-row>
                  <el-col :span="8"><img :src="item.picture" alt="" /> </el-col>
                  <el-col :span="16">
                    <el-button
                      type="text"
                      style="
                          color: #000;
                          font-size: 1rem;
                          white-space: normal !important;
                          line-height: 1.5625rem;
                        "
                      @click="uppeizhi(item.productConfig)"
                    >
                      <v-if v-if="item.partNo != null">
                        我司料号{{ item.partNo }}
                        <br />
                      </v-if>

                      {{ item.productModel }}
                      <br />
                      {{ item.title }}
                      <br />
                      <span> {{ $t("perCar.detailedConfiguration") }} </span>
                      <span></span>
                    </el-button>
                  </el-col>
                </el-row>
                <!-- {{ item.title }} -->
              </el-col>
              <el-col class="fz-col-3" :span="5">
                <el-tag type="success" :precision="3"
                  >{{ $t("perCar.salesPrice") }}:￥{{ item.salesPrice }}</el-tag
                >
                <br />
                <!-- <el-tag
                :precision="3"
                  >{{ $t("perCar.discountPrice") }}:￥{{
                    item.discountPrice
                  }}</el-tag
                > -->
                <br />
                <el-tag type="danger" :precision="3"
                  >{{ $t("perCar.originalPrice") }}:￥{{
                    item.productPrice
                  }}</el-tag
                >
              </el-col>
              <el-col class="fz-col-4" :span="4">
                <el-input-number
                  @change="changeNumber(item.id, item.productNumber)"
                  v-model="item.productNumber"
                  :min="1"
                  size="mini"
                ></el-input-number>
              </el-col>
              <el-col class="fz-col-5" :span="3">
                <el-button type="text" style="color: red; font-size: 1rem">
                  ￥{{
                    formatPrice(
                      (item.salesPrice || item.productPrice) *
                        item.productNumber
                    )
                  }}
                </el-button>
                >
              </el-col>
              <el-col class="fz-col-6" :span="2">
                <span class="lan" @click="upPriceChange(item)">
                  <el-button
                    :precision="3"
                    type="text"
                    style="color: #35a4a0; font-size: 1rem"
                    >{{ $t("perCar.modifyThePrice") }}</el-button
                  ></span
                >
                <br />
                <el-button
                  type="text"
                  @click="del(item.id)"
                  style="color: #222; font-size: 1rem"
                  >{{ $t("perCar.delete") }}</el-button
                >
              </el-col>
            </el-row>
          </li>
        </el-checkbox-group>
      </ul>

      <div class="botBox">
        {{ $t("perCar.selected") }}({{ multipleSelection.length }})
        <div class="fr but" @click="xuanzhong()">
          {{ $t("perCar.settleAccounts") }}
        </div>
        <div class="fr hj">
          {{ $t("perCar.total")
          }}<span class="red">
            ￥{{ getPriceAll(getActivePro()).price }}{{ $t("perCar.cny") }}
          </span>
          &nbsp; &nbsp;
          <span class="red" @click="getPriceAll()">
            {{ $t("perCar.SelectedProduct") }}
            {{ getPriceAll(getActivePro()).selectNumber }}
          </span>
          &nbsp; &nbsp;
          <el-button
            class="fz-col-7"
            type="text"
            @click="openDialogAndFetchProductLines"
          >
            {{ $t("perCar.timeofpayment") }}
          </el-button>
          <el-dialog
            :title="$t('perCar.TheContractInformation')"
            :visible.sync="dialogFormVisibleTime"
            :closeOnClickModal="false"
            :closeOnHashChange="false"
            :showClose="false"
            @open="handleDialogOpen"
          >
            <el-form :model="form" ref="form" :rules="ruleValidate">
              <div v-for="(product, index) in productLines" :key="index">
                <el-form-item :label-width="formLabelWidth" label="产品线选择">
                  <el-col :span="12">
                    <el-form-item>
                      <el-input
                        v-model="product.productTitle"
                        disabled
                        placeholder="产品名称"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :prop="'selectedProductLine.' + index">
                      <el-select
                        v-model="product.productLine"
                        placeholder="请选择产品线"
                      >
                        <el-option
                          v-for="productLine in productLineList"
                          :key="productLine.value"
                          :label="productLine.value"
                          :value="productLine.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-form-item>
              </div>
              <el-form-item
                label="客户名称"
                prop="customerName"
                :label-width="formLabelWidth"
              >
                <el-select
                  v-model="form.customerName"
                  :filterable="true"
                  :remote="true"
                  :remote-method="fetchOptions"
                  placeholder="输入关键字搜索"
                  ref="selectInput"
                  @input="
                    (value) => (form.customerName = value.replace(/\s+/g, ''))
                  "
                >
                  <el-option
                    v-for="option in filterOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="客户名称"
                prop="ERPCustName"
                :label-width="formLabelWidth"
              >
                <el-select
                  v-model="form.ERPCustName"
                  :filterable="true"
                  :remote="true"
                  :remote-method="fetchErpCustomerSuggestions"
                  placeholder="输入ERP付款客户名称"
                  clearable
                >
                  <el-option
                    v-for="option in Erpoptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="是否新签"
                prop="whetherToSignNew"
                :label-width="formLabelWidth"
                :rules="[
                  {
                    required: true,
                    message: '请选择是否新签',
                    trigger: 'change',
                  },
                ]"
              >
                <el-radio-group v-model="form.whetherToSignNew">
                  <el-radio label="新签">新签</el-radio>
                  <el-radio label="复购">复购</el-radio>
                  <el-radio label="维修">维修</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="form.whetherToSignNew === '新签'"
                label="客户创建时间"
              >
                <el-date-picker
                  v-model="repairTime"
                  type="datetime"
                  placeholder="客户创建时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                label="应收款"
                prop="accountReceivable"
                :label-width="formLabelWidth"
                :rules="[
                  { required: true, message: '请输入应收款', trigger: 'blur' },
                ]"
              >
                <el-input v-model="form.accountReceivable" />
              </el-form-item>
              <el-form-item
                label="其他费用"
                prop="otherExpenses"
                :label-width="formLabelWidth"
                :rules="[
                  {
                    required: true,
                    message: '请输入其他费用',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="form.otherExpenses" />
              </el-form-item>
              <el-form-item
                label="业务员名称"
                prop="supplierAgent"
                :label-width="formLabelWidth"
                :rules="[
                  {
                    required: true,
                    message: '请输入业务员名称',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="form.supplierAgent"
                  autocomplete="on"
                  placeholder="请输入业务员名称"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item
                label="备注"
                prop="remark"
                :label-width="formLabelWidth"
              >
                <el-input
                  v-model="form.remark"
                  autosize
                  autocomplete="on"
                  placeholder="备注"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item
                label="付款时效"
                :label-width="formLabelWidth"
                prop="quotationDesc3"
                :rules="[
                  {
                    required: true,
                    message: '请选择付款时效',
                    trigger: 'change',
                  },
                ]"
              >
                <el-select
                  v-model="form.quotationDesc3"
                  placeholder="请选择付款时效"
                >
                  <el-option label="款到发货" value="款到发货"></el-option>
                  <el-option label="备库" value="备库"></el-option>
                  <el-option label="月结30天" value="月结30天"></el-option>
                  <el-option label="月结60天" value="月结60天"></el-option>
                  <el-option label="月结90天" value="月结90天"></el-option>
                  <el-option label="维修" value="维修"></el-option>
                  <el-option
                    label="预付30%，到货付40%，验收合格30%"
                    value="预付30%，到货付40%，验收合格30%"
                  ></el-option>
                  <el-option label="月结120天" value="月结120天"></el-option>
                  <el-option label="月结45天" value="月结45天"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisibleTime = false"
                >取 消</el-button
              >
              <el-button type="primary" @click="dialogForm('form')"
                >确定</el-button
              >
            </div>
          </el-dialog>
        </div>
      </div>
    </el-card>

    <el-dialog
      :title="$t('perCar.modifyThePrice')"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="form">
        <el-form-item
          :label="$t('perCar.originalPrice')"
          :label-width="formLabelWidth"
        >
          <el-input
            disabled
            v-model="form.productPrice"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('perCar.discountPrice')"
          :label-width="formLabelWidth"
        >
          <el-input
            disabled
            v-model="form.discountPrice2"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('perCar.salesPrice')"
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.discountPrice" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{
          $t("perCar.cancel")
        }}</el-button>
        <el-button type="primary" @click="changePrice()">{{
          $t("perCar.confirm")
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('perCar.productConfiguration')"
      :visible.sync="dialogFormVisible2"
    >
      <ul>
        <li v-for="(it, index) in actpeizhi" :key="index">
          <span>{{ it.label }}</span>
          <span v-html="it.value"></span>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible2 = false"
          >确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Store from "../store";
// import axios from "axios";
export default {
  data() {
    return {
      repairTime: "",
      info: "",
      arr: [],
      options: [],
      Erpoptions: [],
      isFetched: false,
      filterOptions: [],
      ErpfilterOptions: [],
      loading: false,
      selectedOption: "",
      store: Store.state,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisibleTime: false,
      form: {
        // 原价
        // repairTime: "",
        productPrice: "",
        // 折扣价格
        discountPrice2: "",
        // 原价特别优惠价格
        discountPrice: "",
        customerName: "",
        ErpcustomerName: "",
        remark: "",
        supplierAgent: "",
        quotationDesc3: "",
        whetherToSignNew: "",
        maintenanceOrNot: "",
        ERPCustName: "",
        accountReceivable: "",
        otherExpenses: "",
        orderCode: "",
        selectedProductLine: "",
      },
      ruleValidate: {
        customerName: [
          { required: true, message: "请填写客户名称", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value && value.includes(" ")) {
                callback(new Error("客户名称不能包含空格"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        supplierAgent: [
          { required: true, message: "请填写业务员名称", trigger: "blur" },
        ],
        whetherToSignNew: [
          { required: true, message: "请选择是否新签", trigger: "blur" },
        ],
        accountReceivable: [
          { required: true, message: "请填写其他费用", trigger: "blur" },
        ],
        otherExpenses: [
          { required: true, message: "请填写业务员名称", trigger: "blur" },
        ],
        formLabelWidth: [
          { required: true, message: "请选择付款时效", trigger: "blur" },
        ],
        // selectedProductLine: [
        //   { required: true, message: "请选择产品线", trigger: "change" },
        // ],
        // remark: [
        //   { required: true, message: '请填写备注', trigger: 'blur' }
        // ],
      },
      formLabelWidth: "7.5rem",
      num: 1,
      list: [],
      multipleSelection: [],
      all: [],
      checkAll: false,
      isIndeterminate: true,
      actpeizhi: [],
      productLine: [],
      productLineList: [
        {
          name: "磁致伸缩类",
          person: "陈新明",
          value: "磁致伸缩类",
          userId: 332,
          alternative: 327,
        },
        {
          name: "PH计/电导率/溶氧",
          person: "陈新明",
          value: "PH计/电导率/溶氧",
          userId: 332,
          alternative: 327,
        },
        {
          name: "分析类",
          person: "陈新明",
          value: "分析类",
          userId: 332,
          alternative: 327,
        },
        {
          name: "容物位计",
          person: "侯乾坤",
          value: "容物位计",
          userId: 327,
          alternative: 332,
        },
        {
          name: "微波/射频/阻旋/音叉物位开关",
          person: "侯乾坤",
          value: "微波/射频/阻旋/音叉物位开关",
          userId: 327,
          alternative: 332,
        },
        {
          name: "跑偏/测速/霍尔开关",
          person: "侯乾坤",
          value: "跑偏/测速/霍尔开关",
          userId: 327,
          alternative: 332,
        },
        {
          name: "物液位计类",
          person: "侯乾坤",
          value: "物液位计类",
          userId: 327,
          alternative: 332,
        },
        {
          name: "浮球液位计",
          person: "邱盼",
          value: "浮球液位计",
          userId: 329,
          alternative: 345,
        },
        {
          name: "浮球/电极/磁性开关",
          person: "邱盼",
          value: "浮球/电极/磁性开关",
          userId: 329,
          alternative: 345,
        },
        {
          name: "物液位开关类",
          person: "邱盼",
          value: "物液位开关类",
          userId: 329,
          alternative: 345,
        },
        {
          name: "雷达/磁翻板/超声波物位计",
          person: "舒亮铭",
          value: "雷达/磁翻板/超声波物位计",
          userId: 345,
          alternative: 329,
        },
        {
          name: "压力类",
          person: "舒亮铭",
          value: "压力类",
          userId: 345,
          alternative: 329,
        },
        {
          name: "超声流量计",
          person: "谢亚伟",
          value: "超声流量计",
          userId: 330,
          alternative: 323,
        },
        {
          name: "温度类",
          person: "谢亚伟",
          value: "温度类",
          userId: 330,
          alternative: 323,
        },
        {
          name: "科里奥利/涡街/涡轮/电磁流量计",
          person: "李星池",
          value: "科里奥利/涡街/涡轮/电磁流量计",
          userId: 323,
          alternative: 357,
        },
        {
          name: "流量计类",
          person: "李星池",
          value: "流量计类",
          userId: 323,
          alternative: 357,
        },
        {
          name: "转子/热式/齿轮/差压流量计",
          person: "吉孟强",
          value: "转子/热式/齿轮/差压流量计",
          userId: 357,
          alternative: 323,
        },
        {
          name: "气动锤/振动器/电磁阀",
          person: "侯乾坤",
          value: "气动锤/振动器/电磁阀",
          userId: 327,
          alternative: 332,
        },


        {
          name: "PFA温度传感器/多点式超声波液位",
          person: "周海健",
          value: "PFA温度传感器/多点式超声波液位",
          userId: 334,
          alternative: 86,
        },
        {
          name: "MFC",
          person: "周海健",
          value: "MFC",
          userId: 334,
          alternative: 86,
        },
        {
          name: "压力类-半导体",
          person: "周海健",
          value: "压力类-半导体",
          userId: 334,
          alternative: 86,
        },
        {
          name: "其他",
          person: "吴晓峰",
          value: "其他",
          userId: 335,
          alternative: 332,
        },
      ],
      // productLineList: [
      //   {
      //     name: "磁致伸缩类",
      //     person: "陈新明",
      //     value: "磁致伸缩类",
      //     userId: 332,
      //     alternative: 0,
      //   },
      //   {
      //     name: "浮球连续式",
      //     person: "邱盼",
      //     value: "浮球连续式",
      //     userId: 329,
      //     alternative: 0,
      //   },
      //   {
      //     name: "电容类/射频导纳",
      //     person: "候乾坤",
      //     value: "电容类/射频导纳",
      //     userId: 327,
      //     alternative: 0,
      //   },
      //   {
      //     name: "微波/阻旋",
      //     person: "查文斌",
      //     value: "微波/阻旋",
      //     userId: 356,
      //     alternative: 327,
      //   },
      //   {
      //     name: "浮球类/电极开关",
      //     person: "邱盼",
      //     value: "浮球类/电极开关",
      //     userId: 329,
      //     alternative: 327,
      //   },
      //   {
      //     name: "跑偏/测速/磁感应开关",
      //     person: "查文斌",
      //     value: "跑偏/测速/磁感应开关",
      //     userId: 356,
      //     alternative: 327,
      //   },
      //   {
      //     name: "超声波流量计/浮子类流量计/热式流量类",
      //     person: "谢亚伟",
      //     value: "超声波流量计/浮子类流量计/热式流量类",
      //     userId: 330,
      //     alternative: 0,
      //   },
      //   {
      //     name: "涡街流量计类/涡轮流量计类",
      //     person: "李星池",
      //     value: "涡街流量计类/涡轮流量计类",
      //     userId: 323,
      //     alternative: 0,
      //   },
      //   {
      //     name: "齿轮流量计类",
      //     person: "吉孟强",
      //     value: "齿轮流量计类",
      //     userId: 357,
      //     alternative: 0,
      //   },
      //   {
      //     name: "节流元件类/流量开关类",
      //     person: "吉孟强",
      //     value: "节流元件类/流量开关类",
      //     userId: 357,
      //     alternative: 0,
      //   },
      //   {
      //     name: "玻璃管玻璃板液位计",
      //     person: "何江楠",
      //     value: "玻璃管玻璃板液位计",
      //     userId: 73,
      //     alternative: 0,
      //   },
      //   {
      //     name: "PH计/电导率/溶氧",
      //     person: "陈新明",
      //     value: "PH计/电导率/溶氧",
      //     userId: 332,
      //     alternative: 0,
      //   },
      //   {
      //     name: "雷达类/超声波物位类",
      //     person: "Rustam",
      //     value: "雷达类/超声波物位类",
      //     userId: 60,
      //     alternative: 324,
      //   },
      //   {
      //     name: "压力类-普通",
      //     person: "舒亮铭",
      //     value: "压力类-普通",
      //     userId: 345,
      //     alternative: 328,
      //   },
      //   {
      //     name: "磁翻板类/电磁流量计类",
      //     person: "舒亮铭",
      //     value: "磁翻板类/电磁流量计类",
      //     userId: 345,
      //     alternative: 328,
      //   },
      //   {
      //     name: "温度类/音叉类",
      //     person: "刘振亚",
      //     value: "温度类/音叉类",
      //     userId: 325,
      //     alternative: 0,
      //   },
      //   {
      //     name: "科里奥利质量流量计",
      //     person: "孙翔宇",
      //     value: "科里奥利质量流量计",
      //     userId: 331,
      //     alternative: 0,
      //   },
      //   {
      //     name: "气动锤/振动器",
      //     person: "",
      //     value: "气动锤/振动器",
      //     userId: 0,
      //     alternative: 0,
      //   },
      //   {
      //     name: "压力开关类/压力表",
      //     person: "顾程",
      //     value: "压力开关类/压力表",
      //     userId: 136,
      //     alternative: 86,
      //   },
      //   {
      //     name: "双金属温度计",
      //     person: "毕辉",
      //     value: "双金属温度计",
      //     userId: 401,
      //     alternative: 0,
      //   },
      //   {
      //     name: "PFA温度传感器/多点式超声波液位",
      //     person: "周海健",
      //     value: "PFA温度传感器/多点式超声波液位",
      //     userId: 334,
      //     alternative: 0,
      //   },
      //   {
      //     name: "MFC",
      //     person: "周海健",
      //     value: "MFC",
      //     userId: 334,
      //     alternative: 0,
      //   },
      //   {
      //     name: "压力类-半导体",
      //     person: "周海健",
      //     value: "压力类-半导体",
      //     userId: 334,
      //     alternative: 0,
      //   },
      //   {
      //     name: "其他",
      //     person: "",
      //     value: "其他",
      //     userId: 0,
      //     alternative: 0,
      //   },
      // ],
      productLines: [],
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  filters: {
    curreny: function(discountPrice) {
      discountPrice = Number(discountPrice).toFixed(5);
      if (discountPrice == parseInt(discountPrice)) {
        discountPrice = parseInt(discountPrice);
      }
      console.log(this.form.discountPrice);
      return discountPrice;
    },
  },

  mounted() {
    this.getUserInfo();
    document.addEventListener("keydown", function(e) {
      if (e.key === "F12" || e.keyCode === 123) {
        e.preventDefault();
      }
    });
    document.addEventListener("contextmenu", function(e) {
      e.preventDefault();
    });
    Store.setPath("3");
    this.init();
  },
  computed: {
    isConfirmButtonDisabled: {
      get() {
        for (let key in this.form) {
          if (!this.form[key]) {
            return true;
          }
        }
        return false;
      },
      set() {},
    },

    totalProductNumber() {
      return this.arr.reduce(
        (total, element) => total + element.productNumber,
        0
      );
    },
    filteredOptions() {
      return this.options.filter((option) =>
        option.label.toLowerCase().includes(this.selectedOption.toLowerCase())
      );
    },
  },
  watch: {
    "form.whetherToSignNew": function(value) {
      if (value === "新签") {
        // 显示时间选择框
        this.$nextTick(() => {
          this.$refs.repairTimeRef.$el.style.display = "";
        });
      } else {
        // 隐藏时间选择框
        this.$nextTick(() => {
          this.$refs.repairTimeRef.$el.style.display = "none";
        });
      }
    },
    form: {
      handler() {
        this.updateIsConfirmButtonDisabled();
      },
      deep: true,
    },
  },

  methods: {
    formatPrice(value) {
      return parseFloat(value.toFixed(6));
    },
    clearForm() {
      this.form = {
        orderCode: "",
        customerName: "",
        ERPCustName: "",
        supplierAgent: "",
        quotationDesc3: "",
        whetherToSignNew: "",
        accountReceivable: "",
        otherExpenses: "",
        remark: "",
      };
      this.updateIsConfirmButtonDisabled(this.form);
    },

    // 新增：打开对话框并获取产品线列表的方法
    openDialogAndFetchProductLines() {
      this.fetchProductLines();
      setTimeout(() => {
        this.dialogFormVisibleTime = true;
      }, 300);
    },
    updateIsConfirmButtonDisabled() {
      let isDisabled = false;
      for (let key in this.form) {
        if (key !== "remark" && !this.form[key]) {
          isDisabled = true;
          break;
        }
      }
      this.$set(this, "isConfirmButtonDisabled", isDisabled);
    },
    handleDialogOpen() {
      if (this.form.orderCode) {
        this.fetchProductLines(this.form.orderCode);
      } else {
        this.$message.error("订单号未设置");
      }
    },
    //查询产品线数据
    async fetchProductLines(orderCode) {
      try {
        const response = await this.$http.get(
          `/c/order/productLine/${orderCode}`
        );
        this.productLines = response.data.data;
      } catch (error) {
        console.error(error);
        this.$message.error("获取产品线数据失败");
      }
    },

    // checkLoginCookie() {
    //   if (Cookies.get('loginCookie')) {
    //     // 存在登录cookie
    //     return true      } else {
    //     // 不存在登录cookie
    //      return false      }
    // },
    uppeizhi(val) {
      this.actpeizhi = val;
      this.dialogFormVisible2 = true;
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Message.success("Success!");
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    async fetchOptions(customerName) {
      if (customerName.includes(" ")) {
        this.$message.error("客户名称不能包含空格");
        return;
      }
      try {
        const response = await this.$http.get(
          `/c/MiddleClientFile/getByCustomerName/${customerName}`
        );
        const data = response.data.data.customerName || [];
        let options = data.map((item) => ({
          value: item,
          label: item,
        }));
        this.options = options;
        this.setFilterOptions(this.customerName);
        if (options.length === 0) {
          this.form.customerName = customerName;
          this.filterOptions = [];
          this.isFetched = true;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async fetchErpCustomerSuggestions(ErpcustomerName) {
      try {
        const response = await this.$http.get(
          `/c/MiddleClientFile/getByErpCustomerName/${ErpcustomerName}`
        );
        const data = response.data.data.customerName || [];
        let options = data.map((item) => ({
          value: item,
          label: item,
        }));
        this.Erpoptions = options; // 将数据赋值给this.Erpoptions
        this.setFilterOptionsErp(ErpcustomerName); // 调用setFilterOptionsErp方法进行过滤
        console.log(this.Erpoptions);
        if (options.length === 0) {
          this.form.ErpcustomerName = ErpcustomerName;
          this.ErpfilterOptions = [];
        }
      } catch (error) {
        console.error(error);
      }
    },

    setFilterOptions(query) {
      if (query) {
        const filteredOptions = this.options.filter(
          (option) =>
            option.label.toLowerCase().indexOf(query.toLowerCase()) > -1
        );
        this.filterOptions = filteredOptions;
      } else {
        this.filterOptions = this.options;
      }
    },
    setFilterOptionsErp(query) {
      if (query) {
        const filteredOptions = this.Erpoptions.filter(
          (option) =>
            option.label.toLowerCase().indexOf(query.toLowerCase()) > -1
        );
        this.ErpfilterOptions = filteredOptions;
        console.log(this.ErpfilterOptions);
      } else {
        this.ErpfilterOptions = this.Erpoptions;
      }
    },

    handleReset(name) {
      this.$refs[name].resetFields();
    },
    // 获取购物车列表
    async init() {
      if (window.sessionStorage.getItem("Authorization")) {
        //是否有token？
        // this.$message.error("已经登录");
        // console.log(window.sessionStorage.getItem("Authorization"));
      } else {
        this.$message.error("请先登录");
      }
      let { data: res } = await this.$http.post("/c/cart/getUserCartList");
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      this.list = res.data.productList;
      for (let i = 0; i < this.list.length; i++) {
        this.all.push(this.list[i].id);
      }
    },

    // 删除购物车
    async del(id) {
      console.log(id);
      let { data: res } = await this.$http.delete("/c/cart/delete", {
        data: [id],
      });
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      this.$message.success("删除成功");
      this.init();
    },
    // 批量删除购物车
    async delAll() {
      let { data: res } = await this.$http.delete("/c/cart/delete", {
        data: this.multipleSelection,
      });
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      this.$message.success("删除成功");
      this.init();
    },
    // 数量改变修改
    change(id, price, number) {
      this.changePrice(id, price);
      this.changeNumber(id, number);
    },
    // 修改数量
    async changeNumber(id, num) {
      console.log(id);
      let { data: res } = await this.$http.put("/c/cart/updateNumber", {
        id: Number(id),
        productNumber: num,
      });
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      this.$message.success("数量修改成功");
      this.init();
    },
    upPriceChange(val) {
      // console.log(val);
      this.form.id = val.id;
      // 原价
      (this.form.productPrice = val.productPrice),
        // 折扣价格
        (this.form.discountPrice2 = val.discountPrice),
        // 原价特别优惠价格
        (this.form.discountPrice = ""),
        (this.dialogFormVisible = true);
    },
    // 修改价格
    async changePrice() {
      let { data: res } = await this.$http.put(
        `/c/cart/updateSalesPrice/${Number(this.form.id)}/${Number(
          this.form.discountPrice
        )}`,
        {
          id: Number(this.form.id),
          discountPrice: Number(this.form.discountPrice),
        }
      );
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      this.$message.success("价格修改成功");
      this.dialogFormVisible = false;
      this.init();
    },
    // 创建订单
    async addOrder() {
      let { data: res } = await this.$http.put("/c/order/add");
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      this.$message.success("修改成功");
    },
    // // 获取选中的商品
    getActivePro() {
      let arr = [];
      for (let i = 0; i < this.list.length; i++) {
        if (this.multipleSelection.indexOf(this.list[i].id) >= 0) {
          arr.push(this.list[i]);
        }
      }
      // console.log(arr);
      return arr;
    },
    // 计算传入的所有价格
    getPriceAll(val) {
      let price = 0;
      let selectNumber = 0;
      for (let i = 0; i < val.length; i++) {
        price +=
          val[i].productNumber * (val[i].salesPrice || val[i].productPrice);
        selectNumber += val[i].productNumber;
      }

      return { price: price.toFixed(2), selectNumber };
    },
    async getUserInfo() {
      let { data: res } = await this.$http.get("/c/user/getInfo");
      if (res) {
        this.info = res.data;
        console.log(this.info);
      }
    },
    //修改选中状态
    async xuanzhong() {
      // console.log(this.info.roleId)
      if (this.info.roleId != 17) {
        let { data: res } = await this.$http.post("/c/cart/updateSelected", {
          idList: [...this.list.map((e) => e.id)],
          isSelected: false,
        });
        if (res.code != 200) {
          return this.$message.error(res.message);
        }
        let { data: res2 } = await this.$http.post("/c/cart/updateSelected", {
          idList: this.multipleSelection,
          isSelected: true,
        });
        if (res2.code != 200) {
          return this.$message.error("请选择要购买的产品");
        }
        this.xiadan();
        console.log(this.info.roleId);
      } else if (this.info.roleId == 17) {
        let { data: res } = await this.$http.post("/c/cart/updateSelected", {
          idList: [...this.list.map((e) => e.id)],
          isSelected: false,
        });
        if (res.code != 200) {
          return this.$message.error(res.message);
        }
        let { data: res2 } = await this.$http.post("/c/cart/updateSelected", {
          idList: this.multipleSelection,
          isSelected: true,
        });
        if (res2.code != 200) {
          return this.$message.error("请选择要购买的产品");
        }
        this.xiadan();
      } else {
        return this.$message.error("暂未开放");
      }
    },
    //客户信息等
    async dialogForm() {
      // this.repairTime = this.repairTime.toISOString().slice(0, 19).replace("T", " ");
      // 表单提交逻辑
      if (
        this.form.customerName != "" &&
        this.form.supplierAgent != "" &&
        this.form.quotationDesc3 != "" &&
        this.form.whetherToSignNew != "" &&
        this.form.accountReceivable != "" &&
        this.form.otherExpenses != ""
      ) {
        let { data: res } = await this.$http.put("/c/order/update/", {
          repairTime: this.repairTime,
          orderCode: this.form.orderCode,
          customerName: this.form.customerName,
          erpCustName: this.form.ERPCustName,
          supplierAgent: this.form.supplierAgent,
          quotationDesc3: this.form.quotationDesc3,
          whetherToSignNew: this.form.whetherToSignNew,
          maintenanceOrNot: this.form.maintenanceOrNot,
          accountReceivable: this.form.accountReceivable,
          otherExpenses: this.form.otherExpenses,
          remark: this.form.remark,
          productLines: this.productLines,
        });
        if (res.code != 200) {
          return this.$message.error(res.message);
        }
        this.$message.success("合同信息成功");
        this.dialogFormVisibleTime = false;
        this.init();
      } else {
        let errorMsg = "";
        if (this.form.customerName == "") {
          errorMsg += "客户名称 为空，";
        }
        if (this.form.supplierAgent == "") {
          errorMsg += "业务员名称 为空，";
        }
        if (this.form.quotationDesc3 == "") {
          errorMsg += "付款时效 为空，";
        }
        if (this.form.whetherToSignNew == "") {
          errorMsg += "是否新签选择 为空，";
        }
        if (this.form.accountReceivable == "") {
          errorMsg += "应收款 为空，";
        }
        if (this.form.otherExpenses == "") {
          errorMsg += "其他费用 为空，";
        }
        // 去掉最后一个逗号
        errorMsg = errorMsg.slice(0, -1);
        this.$message.error(errorMsg);
      }
    },
    // 下单
    async xiadan() {
      let { data: res } = await this.$http.put("/c/order/add");
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      // console.log(res);
      this.form.orderCode = res.data;
      if (res.data === "无权限执行此操作") {
        this.$message.error("无权限执行此操作");
      } else {
        this.$message.success("下单成功");
        this.init();
        this.dialogFormVisibleTime = true;
        this.fetchProductLines();
      }
    },
    handleCheckAllChange(val) {
      this.multipleSelection = val ? this.all : [];
      this.isIndeterminate = false;
    },
    async dialogFormVisibleTimeSubmit() {
      let { data: res } = await this.$http.put("/c/order/add");
      // console.log(res);
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      this.$message.success("选择成功");
    },
  },
};
</script>
<style lang="less" scoped>
.msg {
  // width: 67.5rem;
  //   height: 46.875rem;

  input {
    width: 40%;
    border: none;
    padding: 0.3125rem;
  }

  .title {
    color: rgb(67, 188, 183);
    line-height: 2.5rem;
    border-bottom: 0.25rem solid rgb(67, 188, 183);
  }

  .topBox,
  .botBox {
    margin-top: 1.875rem;
    height: 3.125rem;
    padding: 0.625rem 1.25rem;
    box-sizing: border-box;
    background-color: #f1f1f1;
    border: 0.0313rem solid #ccc;
  }

  ul {
    li {
      margin: 0.625rem 0;
      border: 0.0313rem solid #ccc;
      box-sizing: border-box;
      height: 8.75rem;
      padding: 1.25rem;
      display: table;
      width: 100%;

      .fz-col-1 {
        padding-top: 2.5rem;
      }

      .fz-col-2 {
        line-height: 6.25rem;

        img {
          width: 6.25rem;
          height: 6.25rem;
          border: 0.0313rem solid #ccc;
          float: left;
          margin-right: 0.625rem;
        }
      }

      .fz-col-3 {
        // padding-top: 1.25rem;
        line-height: 1.25rem;

        .yuan {
          color: #ccc;
        }

        .el-tag {
          margin-top: 0.3125rem;
        }
      }

      .fz-col-4 {
        padding-top: 2.5rem;
      }

      .fz-col-5 {
        padding-top: 2.5rem;
        color: rgb(184, 37, 37);
      }

      .fz-col-6 {
        padding-top: 1.25rem;
        line-height: 1.875rem;
      }

      .fz-col-7 {
        margin-right: 40px;
        font-size: 1rem;
      }

      .el-button + .el-button {
        margin-left: 0px;
      }
    }
  }

  .botBox {
    padding: 0;
    line-height: 1.25rem;
    line-height: 3.125rem;
    padding-left: 1.25rem;

    .but {
      margin: 0;
      display: inline-block;
      border-radius: 0;
      padding: 0 2.5rem;
      height: 3rem;
    }

    .hj {
      margin-right: 1.25rem;
    }

    .red {
      font-size: 1.125rem;
    }
  }
}
</style>
